import type { SVGProps } from "react";

export default function ContextIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.677 6.34162C5.677 5.97456 5.97456 5.677 6.34162 5.677H11.6585C12.0256 5.677 12.3232 5.97456 12.3232 6.34162C12.3232 6.70867 12.0256 7.00623 11.6585 7.00623H9.66469V11.6585C9.66469 12.0256 9.36712 12.3232 9.00008 12.3232C8.63303 12.3232 8.33546 12.0256 8.33546 11.6585V7.00623H6.34162C5.97456 7.00623 5.677 6.70867 5.677 6.34162Z"
        fill="currentColor"
      />
      <circle
        cx="15.6464"
        cy="2.35392"
        r="1.66154"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <circle
        cx="2.35392"
        cy="2.35392"
        r="1.66154"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <circle
        cx="15.6464"
        cy="15.6462"
        r="1.66154"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <circle
        cx="2.35392"
        cy="15.6462"
        r="1.66154"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <path
        d="M2.354 4.01538V13.9846"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <path
        d="M15.6462 4.01538V13.9846"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <path
        d="M13.9849 2.354L4.01563 2.354"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
      <path
        d="M13.9849 15.6462L4.01563 15.6462"
        stroke="currentColor"
        strokeWidth="1.24615"
      />
    </svg>
  );
}
